import React from 'react';
import styles from 'components/layout/Footer.module.css';  // Fichier CSS pour le Footer

const MetaFooter = () => {

  return (
    <div className={`global-container ${styles.legalsContainer}`}>
      <p>© {new Date().getFullYear()} Le Pharos Arras. Tous droits réservés.</p>
      <ul className={`list--none ${styles.legals}`}>
        <li><a href="/conditions-generales" className={`arrow-link ${styles.legalItem}`} aria-label="Voir les conditions générales" title="Voir les conditions générales">Conditions générales</a></li>
        <li><a href="/mentions-legales" className={`arrow-link ${styles.legalItem}`} aria-label="Voir les mentions légales" title="Voir les mentions légales">Mentions légales</a></li>
        <li><a href="/cookies" className={`arrow-link ${styles.legalItem}`} aria-label="Voir la politique de cookies" title="Voir la politique de cookies">Cookies</a></li>
      </ul>
    </div>
  );

};

export default MetaFooter;
